var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.9938C17.24 15.9938 16.56 16.2922 16.04 16.7596L8.91 12.6319C8.96 12.4031 9 12.1744 9 11.9356C9 11.6969 8.96 11.4682 8.91 11.2394L15.96 7.15143C16.5 7.64875 17.21 7.95709 18 7.95709C19.66 7.95709 21 6.62427 21 4.97317C21 3.32207 19.66 1.98926 18 1.98926C16.34 1.98926 15 3.32207 15 4.97317C15 5.21188 15.04 5.44065 15.09 5.66942L8.04 9.75738C7.5 9.26006 6.79 8.95172 6 8.95172C4.34 8.95172 3 10.2845 3 11.9356C3 13.5867 4.34 14.9196 6 14.9196C6.79 14.9196 7.5 14.6112 8.04 14.1139L15.16 18.2516C15.11 18.4605 15.08 18.6793 15.08 18.8981C15.08 20.4995 16.39 21.8024 18 21.8024C19.61 21.8024 20.92 20.4995 20.92 18.8981C20.92 17.2967 19.61 15.9938 18 15.9938ZM18 3.97853C18.55 3.97853 19 4.42612 19 4.97317C19 5.52022 18.55 5.96781 18 5.96781C17.45 5.96781 17 5.52022 17 4.97317C17 4.42612 17.45 3.97853 18 3.97853ZM6 12.9303C5.45 12.9303 5 12.4827 5 11.9356C5 11.3886 5.45 10.941 6 10.941C6.55 10.941 7 11.3886 7 11.9356C7 12.4827 6.55 12.9303 6 12.9303ZM18 19.9126C17.45 19.9126 17 19.465 17 18.918C17 18.3709 17.45 17.9234 18 17.9234C18.55 17.9234 19 18.3709 19 18.918C19 19.465 18.55 19.9126 18 19.9126Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.27095a43a09429620288271e2860f869.svg";
export { ForwardRef as ReactComponent };